enum Language {
  DA_DK = 'da_dk',
  DE = 'de',
  EL_GR = 'el_gr',
  EN_GB = 'en_gb',
  EN_US = 'en_us',
  ES = 'es',
  ET_EE = 'et_ee',
  FI_FI = 'fi_fi',
  FR = 'fr',
  HR_HR = 'hr_hr',
  IT = 'it',
  JA_JP = 'ja_jp',
  LT_LT = 'lt_lt',
  LV_LV = 'lv_lv',
  NL = 'nl',
  NO = 'no',
  PL = 'pl',
  PT = 'pt',
  RO_RO = 'ro_ro',
  SV = 'sv',
  RU = 'ru',
  UK = 'uk',
  BG_BG = 'bg_bg',
  BS_BA = 'bs_ba',
  HU_HU = 'hu_hu',
  SR_RS = 'sr_rs',
  FIL_PH = 'fil_ph',
  KO_KR = 'ko_kr',
  MS_MY = 'ms_my',
  ZH_CN = 'zh_cn',
  ZH_HK = 'zh_hk',
  ZH_TW = 'zh_tw'

}
export default Language;
